import React, { Component } from "react";
import { connect } from "react-redux";
import CenteredPaper from "../layouts/CenteredPaper";
import { IrqTitle } from "../molecules/IrqTitle";
import { withSubmissionEffect } from "../util/hocs/withSubmissionEffect";
import { BigButton } from "../atoms/buttons/BigButton";
import ILearn from "../molecules/ILearn";

class IrqPropertyTypeView extends Component {
  render() {
    return (
      <ILearn content={this.props.content}>
        <CenteredPaper>
          <IrqTitle
            content={this.props.content}
            icon="/img/svg_icons/property_type.svg"
          />
          <div className="property-type-wrapper">
            <div className="property-view-wrapper">
              <BigButton
                icon="/img/svg_icons/Single_Family.svg"
                title="Single Family"
                selected={this.props.data.propertyType === "Single"}
                onClick={() => {
                  this.props.customFormEdit("propertyType", "Single");
                  this.props.navigationContext.goNext(
                    this.props.navigationsAway.Primary,
                    true
                  );
                }}
              />
              <BigButton
                icon="/img/svg_icons/Townhouse.svg"
                title="Townhouse"
                selected={this.props.data.propertyType === "Townhome"}
                onClick={() => {
                  this.props.customFormEdit("propertyType", "Townhome");
                  this.props.navigationContext.goNext(
                    this.props.navigationsAway.Primary,
                    true
                  );
                }}
              />
            </div>
            <div className="property-view-wrapper">
              <BigButton
                icon="/img/svg_icons/Condo.svg"
                title="Condo"
                selected={this.props.data.propertyType === "Condo"}
                onClick={() => {
                  this.props.customFormEdit("propertyType", "Condo");
                  this.props.navigationContext.goNext(
                    this.props.navigationsAway.Primary,
                    true
                  );
                }}
              />
              <BigButton
                icon="/img/svg_icons/Duplex.svg"
                title="Duplex"
                selected={this.props.data.propertyType === "Duplex"}
                onClick={() => {
                  this.props.customFormEdit("propertyType", "Duplex");
                  this.props.navigationContext.goNext(
                    this.props.navigationsAway.Primary,
                    true
                  );
                }}
              />
            </div>
            <div className="property-view-wrapper">
              <BigButton
                icon="/img/svg_icons/Triplex.svg"
                title="Triplex"
                selected={this.props.data.propertyType === "Triplex"}
                onClick={() => {
                  this.props.customFormEdit("propertyType", "Triplex");
                  this.props.navigationContext.goNext(
                    this.props.navigationsAway.Primary,
                    true
                  );
                }}
              />
              <BigButton
                icon="/img/svg_icons/Quadraplex.svg"
                title="Quadraplex"
                selected={this.props.data.propertyType === "Quadplex"}
                onClick={() => {
                  this.props.customFormEdit("propertyType", "Quadplex");
                  this.props.navigationContext.goNext(
                    this.props.navigationsAway.Primary,
                    true
                  );
                }}
              />
            </div>
          </div>
        </CenteredPaper>
      </ILearn>
    );
  }
}

export default withSubmissionEffect(connect()(IrqPropertyTypeView));
